import styled from "styled-components";
import {styledByDevice} from "../../../../../../themes/architecture/styled-by-device";

const SearchInputMutual = styled.input`
    background: transparent/* ${props => props.theme.colors.background} */;
    color: ${props => props.theme.colors.textLight};   

    &:focus {
        outline: none;
    }

    border: 2px solid ${props => props.theme.colors.boxBorderLighter};
    border-radius: 4rem;
    font-size: 1.5rem;
`;

const SearchInputAreaPCBox = styled(SearchInputMutual)`
    width: 0;
    padding: 0.90rem 1.8rem;
    font-weight: 600;
  
    transition: width 0.5s ease, padding 0.5s ease;
    cursor: pointer;

    &:focus {
        transition: width 0.5s ease, padding 0.5s ease;
        width: 25rem;
        padding-left: 5rem;
    }
    &::placeholder {
        color: ${props => props.theme.colors.textMiddleDark};
    }
`;

const SearchInputAreaMobileBox = styled(SearchInputMutual)`
    width: 100%;
    padding: 1.4rem 1rem 1.4rem 5.7rem;
    font-weight: 300;
  
    &::placeholder{
        color: ${props => props.theme.colors.textLight};
    }
`;

export const SearchInputAreaCasino888Box = styledByDevice(SearchInputAreaPCBox, SearchInputAreaMobileBox);